module.exports = __webpack_public_path__ + "static/media/BuiltSmartFull.4ebfb9ad.svg";